import { keyBy, values } from 'lodash';

/**
 * Replaces objects in the first array with ones from the second array
 * based on a shared key. Objects in arr2 take priority.
 */
export function replaceByKey<T>(arr1: T[], arr2: T[], key: keyof T): T[] {
    const obj1 = keyBy(arr1, key);
    const obj2 = keyBy(arr2, key);
    const combined = { ...obj1, ...obj2 }; // arr2 overrides arr1
    return values(combined);
}
